import React, { ReactNode } from 'react';
import cn from 'classnames';

import styles from './action-buttons-wrapper.module.scss';

interface IActionButtonsWrapperProps {
  leftButton?: ReactNode;
  rightButton?: ReactNode;
  showDivider?: boolean;
}

export default function ActionButtonsWrapper({
  leftButton,
  rightButton,
  showDivider = true
}: IActionButtonsWrapperProps) {
  return (
    <div
      className={cn(styles['action-buttons'], {
        [styles.divider]: showDivider
      })}
    >
      <div className={styles['button-wrapper']}>
        {leftButton}
      </div>

      <div className={styles['button-wrapper']}>
        {rightButton}
      </div>
    </div>
  );
}
